import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { familyMetrics, seniorMetrics } from "@/lib/proposalData";
import { useDeployment } from "@/lib/DeploymentContext";

function MetricsTable({ title, rows, testId }) {
  return (
    <div data-testid={testId} className="bg-white border border-[#CBD5E1]">
      <div className="px-6 py-5 border-b border-[#CBD5E1] flex items-baseline justify-between">
        <h3 className="font-display text-xl text-[#0A192F]">{title}</h3>
        <span className="font-mono text-[10px] uppercase tracking-widest text-[#8B0000]">
          Intake Matrix
        </span>
      </div>
      <Table>
        <TableHeader>
          <TableRow className="bg-[#F9F7F1] border-b border-[#CBD5E1] hover:bg-[#F9F7F1]">
            <TableHead className="font-mono text-[10px] uppercase tracking-widest text-[#0A192F] w-[18%]">
              Domain
            </TableHead>
            <TableHead className="font-mono text-[10px] uppercase tracking-widest text-[#8B0000]">
              Low Stability · Action Required
            </TableHead>
            <TableHead className="font-mono text-[10px] uppercase tracking-widest text-[#475569]">
              Progressing
            </TableHead>
            <TableHead className="font-mono text-[10px] uppercase tracking-widest text-[#0A192F]">
              Thriving · Goal
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map((r) => (
            <TableRow key={r.domain} className="border-b border-[#E2E8F0] last:border-0">
              <TableCell className="font-display text-base text-[#0A192F] align-top py-5">
                {r.domain}
              </TableCell>
              <TableCell className="text-sm text-[#475569] align-top py-5 border-l border-[#E2E8F0]">
                <span className="block w-6 h-1 bg-[#8B0000] mb-2" />
                {r.low}
              </TableCell>
              <TableCell className="text-sm text-[#475569] align-top py-5 border-l border-[#E2E8F0]">
                <span className="block w-6 h-1 bg-[#D4AF37] mb-2" />
                {r.progressing}
              </TableCell>
              <TableCell className="text-sm text-[#334155] align-top py-5 border-l border-[#E2E8F0]">
                <span className="block w-6 h-1 bg-[#0A192F] mb-2" />
                {r.thriving}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}

export default function IntakeFramework() {
  const d = useDeployment();
  return (
    <section
      id="framework"
      data-testid="section-intake-framework"
      className="bg-[#F9F7F1] py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-3">
              <span className="h-px w-8 bg-[#8B0000]" />
              <span className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#8B0000]">
                03 — Intake & Assessment Framework
              </span>
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#0A192F] leading-tight">
              How we measure a starting baseline — and how we know we're winning.
            </h2>
          </div>
          <div className="lg:col-span-7 lg:pt-2">
            <p className="text-[#334155] text-base leading-relaxed">
              Every household and every senior moves through a standardized intake on
              day one. The connector scores stability across four domains for families
              and three for seniors. Progress between domains over 12–24 months is the
              {d.intakeReportLine}
              partners who fund this work.
            </p>
          </div>
        </div>

        <div className="space-y-10">
          <MetricsTable testId="table-family-metrics" title="Whole-Family Stability — Core Metrics" rows={familyMetrics} />
          <MetricsTable testId="table-senior-metrics" title="Senior Stability — Core Metrics" rows={seniorMetrics} />
        </div>
      </div>
    </section>
  );
}
